import React, { useState, useEffect } from 'react';
import './App.css';

const RESUME = {
  profile: {
    name: "Vishwa Panchal",
    role: "R&D Intern | Cloud & DevOps Engineer",
    contact: "+91 8277665467 | Bengaluru, India",
    links: [
      { name: "LinkedIn", url: "https://linkedin.com/in/vishwa-panchal", icon: "🔗" },
      { name: "GitHub", url: "https://github.com/vishwa-panchal", icon: "💻" },
      { name: "Email", url: "mailto:contact@vishwa.com", icon: "✉️" }
    ]
  },
  education: [
    { school: "R. V College of Engineering", degree: "B.E in Information Science", year: "2024 - Present" },
    { school: "Government Polytechnic", degree: "Diploma in CS (CGPA 9.73)", year: "2021 - 2023" }
  ],
  experience: [
    {
      company: "ProLEAP Academy", role: "R&D Intern", duration: "Jan 2024 - Apr 2024",
      bullets: [
        "Selected as top performer (Cohort of 60+) for virtualization infra.",
        "Configured Linux environments & automated admin tasks.",
        "Deployed containerized apps (Docker/K8s) & built CI/CD pipelines."
      ]
    }
  ],
  projects: [
    {
      name: "Cloud-Hosted EL Platform", stack: "AWS EC2, FastAPI, PostgreSQL",
      desc: "Deployed full-stack app on AWS with FAISS Vector DB for plagiarism detection."
    },
    {
      name: "Gram Sahayak Governance", stack: "MongoDB, WebSockets, Leaflet",
      desc: "Real-time governance system with geo-tracking and AI chatbot assistant."
    }
  ],
  skills: {
    "Cloud & DevOps": ["AWS", "Docker", "Kubernetes", "Jenkins", "Terraform", "Ansible"],
    "Backend": ["FastAPI", "Python", "SQL", "Microservices"],
    "Tools": ["Git", "Linux", "VS Code"]
  },
  certs: [
    "GCP Cloud Arcade (Jun 2025)",
    "Cisco Networking Basics (Mar 2025)",
    "Udemy DSA (Jul 2022)"
  ]
};

function App() {
  const [time, setTime] = useState(new Date().toLocaleTimeString());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date().toLocaleTimeString()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="container">
      
      {/* 1. TOP MARQUEE */}
      <div className="marquee-container">
        <marquee scrollamount="8">
          *** VISHWA PANCHAL *** CLOUD & DEVOPS ENGINEER *** SYSTEM ONLINE *** WELCOME VISITOR ***
        </marquee>
      </div>

      {/* 2. PROFILE HERO (Full Width) */}
      <div className="window">
        <div className="title-bar"><span>USER_PROFILE.SYS</span><div className="title-bar-controls"><button>X</button></div></div>
        <div className="window-body profile-container">
          <img 
            src={process.env.PUBLIC_URL + '/profile.jpg'} 
            alt="Profile"
            className="profile-pic"
            onError={(e) => {e.target.style.display='none'; e.target.nextSibling.style.display='flex'}}
          />
          <div style={{display:'none', width:'130px', height:'130px', background:'#fff', border:'2px inset #fff', alignItems:'center', justifyContent:'center'}}>NO IMG</div>

          <div style={{flex: 1}}>
            <h1 style={{fontFamily: 'Times New Roman', margin: '0 0 5px 0', fontSize: '2.5rem'}}>{RESUME.profile.name}</h1>
            <div style={{fontSize:'1.2rem', color:'#000080', fontWeight:'bold', marginBottom:'10px'}}>{RESUME.profile.role}</div>
            <div style={{fontFamily:'Courier New'}}>{RESUME.profile.contact}</div>
            <div style={{marginTop: '15px'}}>
              {RESUME.profile.links.map((l, i) => (
                <a key={i} href={l.url} className="retro-btn" target="_blank" rel="noreferrer">
                  <span>{l.icon}</span> {l.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 3. MAIN GRID (Left: Work/Projects, Right: Sidebar) */}
      <div className="main-layout">
        
        {/* LEFT COLUMN: THE STORY */}
        <div className="left-col">
          
          {/* WORK HISTORY */}
          <div className="window">
            <div className="title-bar"><span>EXPERIENCE.LOG</span></div>
            <div className="window-body">
              {RESUME.experience.map((exp, i) => (
                <div key={i} className="work-item">
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <h3 style={{margin:0, color:'#000080'}}>{exp.company}</h3>
                    <span style={{background:'#eee', border:'1px solid #888', padding:'2px 5px', fontSize:'0.8rem'}}>{exp.duration}</span>
                  </div>
                  <div style={{fontStyle:'italic', marginBottom:'8px'}}>{exp.role}</div>
                  <ul style={{paddingLeft:'20px', margin:0, fontSize:'0.9rem', lineHeight:'1.5'}}>
                    {exp.bullets.map((b, j) => <li key={j}>{b}</li>)}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* PROJECTS */}
          <div className="window">
            <div className="title-bar"><span>PROJECTS.DIR</span></div>
            <div className="window-body">
              {RESUME.projects.map((proj, i) => (
                <div key={i} className="project-card">
                   <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'8px'}}>
                      <strong style={{fontSize:'1.1rem'}}>{proj.name}</strong>
                      <span style={{fontSize:'1.2rem'}}>💾</span>
                   </div>
                   <div style={{fontSize:'0.85rem', marginBottom:'8px'}}>{proj.desc}</div>
                   <div style={{fontSize:'0.75rem', fontFamily:'Courier New', background:'#eee', padding:'3px'}}>
                     STACK: {proj.stack}
                   </div>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* RIGHT COLUMN: THE TOOLKIT */}
        <div className="right-col">
          
          {/* SKILLS */}
          <div className="window">
            <div className="title-bar"><span>SKILLS.CFG</span></div>
            <div className="window-body">
              {Object.entries(RESUME.skills).map(([cat, items]) => (
                <div key={cat} style={{marginBottom:'15px'}}>
                  <div style={{fontWeight:'bold', fontSize:'0.85rem', marginBottom:'5px', textDecoration:'underline'}}>{cat}</div>
                  <div>
                    {items.map(s => <span key={s} className="skill-tag">{s}</span>)}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* EDUCATION */}
          <div className="window">
            <div className="title-bar"><span>EDUCATION.TXT</span></div>
            <div className="window-body" style={{padding:'15px'}}>
              {RESUME.education.map((edu, i) => (
                <div key={i} style={{marginBottom:'12px', borderBottom:'1px dotted #888', paddingBottom:'8px'}}>
                  <div style={{fontWeight:'bold', fontSize:'0.9rem'}}>{edu.school}</div>
                  <div style={{fontSize:'0.85rem'}}>{edu.degree}</div>
                  <div style={{fontSize:'0.8rem', color:'#555'}}>{edu.year}</div>
                </div>
              ))}
            </div>
          </div>

          {/* CERTIFICATES */}
          <div className="window">
            <div className="title-bar"><span>CERTS.DAT</span></div>
            <div className="window-body">
              <ul className="sidebar-list">
                {RESUME.certs.map((c, i) => (
                  <li key={i} className="sidebar-item" style={{display:'flex', gap:'8px', alignItems:'center'}}>
                    <span style={{color:'gold'}}>★</span> {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>

      {/* 4. TASKBAR */}
      <div className="taskbar">
        <button className="start-btn">
          <img src="https://win98icons.alexmeub.com/icons/png/windows-0.png" width="18" alt="win" />
          Start
        </button>
        <div style={{borderLeft:'2px solid #888', height:'20px', marginLeft:'5px'}}></div>
        <div className="task-tray">
          {time}
        </div>
      </div>

    </div>
  );
}

export default App;
